// extracted by mini-css-extract-plugin
export default {"footer":"footer__DGBa9","active":"active__O32Hl","small":"small__ba-oe"};